export function linkToRegisters() {
  return "/registers";
}

export function linkToRegistersPatient() {
  return `${linkToRegisters()}/patient`;
}

export const linkToRegistersPatientDownload = () => {
  return `${linkToRegistersPatient()}/download`;
};

export function linkToRegistersAnc() {
  return `${linkToRegisters()}/anc`;
}

export function linkToRegistersAncDownload() {
  return `${linkToRegistersAnc()}/download`;
}

export function linkToRegistersChildImmunisation() {
  return `${linkToRegisters()}/child-immunisation`;
}

function linkToRegistersNigeria() {
  return `${linkToRegisters()}/nigeria`;
}

export function linkToRegistersNigeriaDailyOutpatient() {
  return `${linkToRegistersNigeria()}/daily-outpatient`;
}

export function linkToRegistersNigeriaDailyOutpatientDownload() {
  return `${linkToRegistersNigeriaDailyOutpatient()}/download`;
}

export function linkToRegistersNigeriaGeneralAttendance() {
  return `${linkToRegistersNigeria()}/general-attendance`;
}

export function linkToRegistersNigeriaGeneralAttendanceDownload() {
  return `${linkToRegistersNigeriaGeneralAttendance()}/download`;
}

export const linkToRegistersDownloadRequests = () => {
  return `${linkToRegisters()}/download-requests`;
};
